// extracted by mini-css-extract-plugin
export var page = "_redotech-redo-return-app-lib-mobile-upload-mobile-upload-page-page";
export var successIcon = "_redotech-redo-return-app-lib-mobile-upload-mobile-upload-page-successIcon";
export var thumbnail = "_redotech-redo-return-app-lib-mobile-upload-mobile-upload-page-thumbnail";
export var thumbnailGrid = "_redotech-redo-return-app-lib-mobile-upload-mobile-upload-page-thumbnail-grid";